export const getStringForLineBreak = string => {
  const subString = string.split('++')

  return subString
}
